// TODO: Need to work on different guides to help user add to home screen. Should have one per device / browser.

const InstallViaAddToHomeScreen = () => null;

export default InstallViaAddToHomeScreen;
